module.exports = __webpack_public_path__ + "img/st-line-long.afb4fb56.svg";